import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, ViewChild, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';

class BmxZoomifyService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class BmxZoomifyComponent {
    constructor(_document, _renderer) {
        this._document = _document;
        this._renderer = _renderer;
        this.src = {
            url: '',
            altText: ''
        };
        this.zoomDiv = {};
    }
    ngOnInit() {
    }
    zoom(e) {
        if (e.currentTarget === null)
            return;
        let imgElement = e.currentTarget;
        if (screen.width > 759) {
            const { offsetX, offsetY } = e;
            const offsetWidth = imgElement.offsetWidth;
            const offsetHeight = imgElement.offsetHeight;
            const x = offsetX / offsetWidth * 100;
            const y = offsetY / offsetHeight * 100;
            const pos = `${x}% ${y}%`;
            this._renderer.setStyle(imgElement, "background-position", pos);
            if (this.src) {
                this._renderer.setStyle(this.zoomDiv.nativeElement, "background-image", `url(${this.src.url})`);
            }
        }
    }
    zoomOut() {
        this._renderer.setStyle(this.zoomDiv.nativeElement, "background-image", `url()`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyComponent, deps: [{ token: DOCUMENT }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: BmxZoomifyComponent, selector: "bmx-zoomify", inputs: { src: "src" }, viewQueries: [{ propertyName: "zoomDiv", first: true, predicate: ["zoomDiv"], descendants: true }], ngImport: i0, template: "<div class=\"bmx-zoomify-main-image-container bmx-zoomify-pig-zoom\"\n\t #zoomDiv\n\t (mousemove)=\"zoom($event)\" (mouseleave)=\"zoomOut()\">\n\t<img [src]=\"src.url\"\n\t\t class=\"bmx-pig-main-image\"\n\t\t [width]=\"src.width? src.width: 'auto'\"\n\t\t [height]=\"src.width? src.height: 'auto'\"\n\t\t [alt]=\"src.altText\" />\n</div>\n", styles: [".bmx-zoomify-main-image-container{display:flex;justify-content:center;align-items:center;position:relative;overflow:hidden}.bmx-zoomify-pig-zoom{background-position:50% 50%;overflow:hidden;background-size:max(100%,1000px)}.bmx-zoomify-pig-zoom img{width:100%;cursor:crosshair;transition:opacity .5s;margin:5px 0}@media (min-width: 759px){.bmx-zoomify-pig-zoom img:hover{opacity:0}}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmx-zoomify', template: "<div class=\"bmx-zoomify-main-image-container bmx-zoomify-pig-zoom\"\n\t #zoomDiv\n\t (mousemove)=\"zoom($event)\" (mouseleave)=\"zoomOut()\">\n\t<img [src]=\"src.url\"\n\t\t class=\"bmx-pig-main-image\"\n\t\t [width]=\"src.width? src.width: 'auto'\"\n\t\t [height]=\"src.width? src.height: 'auto'\"\n\t\t [alt]=\"src.altText\" />\n</div>\n", styles: [".bmx-zoomify-main-image-container{display:flex;justify-content:center;align-items:center;position:relative;overflow:hidden}.bmx-zoomify-pig-zoom{background-position:50% 50%;overflow:hidden;background-size:max(100%,1000px)}.bmx-zoomify-pig-zoom img{width:100%;cursor:crosshair;transition:opacity .5s;margin:5px 0}@media (min-width: 759px){.bmx-zoomify-pig-zoom img:hover{opacity:0}}\n"] }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.Renderer2 }], propDecorators: { src: [{
                type: Input
            }], zoomDiv: [{
                type: ViewChild,
                args: ['zoomDiv']
            }] } });

class BmxZoomifyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyModule, declarations: [BmxZoomifyComponent], exports: [BmxZoomifyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BmxZoomifyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BmxZoomifyComponent
                    ],
                    imports: [],
                    exports: [
                        BmxZoomifyComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of bmx-zoomify
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BmxZoomifyComponent, BmxZoomifyModule, BmxZoomifyService };
